<div class="validation-modal" [hidden]="showing==='none'">
    <div class="validation-modal-container" [ngClass]="{'transparent': showing==='init'}">
        <div class="content-container" [ngSwitch]="showing">
            <div class="mfa-choose" *ngSwitchCase="'mfa'">
                <span class="title">Additional Information Required</span>
                <div class="content">
                    <div>Additional security has been applied to this Exchange.</div>
                    <div>An authentication code is required.</div>
                </div>
                <span class="content"><strong>Please select a delivery method for the code.</strong></span>

                <div class="underline">Mobile</div>
                <label>
                    <tam-radio [value]="'phone'" [(ngModel)]="mfaSelection"></tam-radio>
                    &nbsp;***&nbsp;***&nbsp;{{mfa['mobile-numbers']['mobile-number']}}
                </label>
                <span class="remark">Standard text messaging rates may apply.</span>
                <div class="underline">Email</div>
                <label>
                    <tam-radio [value]="'email'" [(ngModel)]="mfaSelection"></tam-radio>&nbsp;{{mfa['email']}}
                </label>
                <div class="btn-grroup">
                    <button tam-button tid="splash-cancel" [tamType]="'secondary'" [tamSize]="'normal'"
                        (click)="cancel()">Cancel</button>
                    <button tam-button tid="splash-accept" [tamType]="'primary'" [tamSize]="'normal'"
                        (click)="chooseMFA()">Send Code</button>
                </div>
            </div>
            <div class="mfa-password" *ngSwitchCase="'password'">
                <div class="underline">Password</div>
                <input class="tam-input" type="text" [(ngModel)]="mfa['password']">
                <div class="btn-grroup">
                    <button tam-button tid="splash-back" [tamType]="'secondary'" [tamSize]="'normal'"
                        (click)="backToSendPage()">Back</button>
                    <button tam-button tid="splash-cancel" [tamType]="'secondary'" [tamSize]="'normal'"
                        (click)="cancel()">Cancel</button>
                    <button tam-button tid="splash-submit" [tamType]="'primary'" [tamSize]="'normal'"
                        (click)="submitPassword()" [disabled]="!mfa['password']">Submit</button>
                </div>
            </div>
            <div class="splash" *ngSwitchCase="'splash'">
                <div class="image-container">
                    <img [src]="splashImage">
                </div>
                <tam-html-container [html]="splash['content']"></tam-html-container>
                <div class="btn-grroup">
                    <button tam-button tid="splash-cancel" [tamType]="'secondary'" [tamSize]="'normal'"
                        (click)="cancel()">Cancel</button>
                    <button tam-button tid="splash-accept" [tamType]="'primary'" [tamSize]="'normal'"
                        (click)="acceptSplash()">{{splash['acceptText']}}</button>
                </div>
            </div>
            <div class="spin" *ngSwitchDefault>
                <div loading-spin [isLoading]="true" [loadingSize]="'big'"></div>
            </div>

        </div>
    </div>
</div>